/**
 * API url
 */
export const API_URL = 'https://api.udilia.com/coins/v1';



// WEBPACK FOOTER //
// ./src/config.js